// @flow

import React from "react";
import { localize } from "redux-i18n";
import { ColumnsContainer } from "@components";
import type { Rows } from "@components/columns-container/types";
import type { DynamicQuestionContent } from "@modules/service/reducer/dynamic-questions/types";
import { toTitleCase, transformBooleanToString } from "@transformers/response";

type Props = $Exact<{
  data?: DynamicQuestionContent,
  ...PropsFromLocalize,
}>;

export class DynamicQuestionQuestionTypeView extends React.Component<Props> {
  get data(): Array<Rows> {
    if (!this.props.data) return [];
    const data = this.props.data || {};
    return [
      {
        columns: [
          {
            data: [
              [this.props.t("QUESTION_TEXT"), data.questionText],
              [this.props.t("QUESTION_TYPE"), toTitleCase(data.questionType.replace("_", " "))],
              [
                this.props.t("MANDATORY"),
                transformBooleanToString("isMandatory", this.props.t)(data),
              ],
            ],
          },
          {
            data: [
              [this.props.t("ADVISOR_TYPE"), this.props.t(data.advisorType || "N/A")],
              [
                this.props.t("START_NOTIFICATION"),
                transformBooleanToString("startNotification", this.props.t)(data),
              ],
            ],
          },
          {
            data: [
              [
                this.props.t("UPDATE_NOTIFICATION"),
                transformBooleanToString("updateNotification", this.props.t)(data),
              ],
              [
                this.props.t("CLOSE_NOTIFICATION"),
                transformBooleanToString("closeNotification", this.props.t)(data),
              ],
            ],
          },
        ],
      },
    ];
  }

  render() {
    return <ColumnsContainer rows={this.data} />;
  }
}

export default localize()(DynamicQuestionQuestionTypeView);
